import React, { useRef, useState, useMemo, useCallback } from "react";
import { Modal, Descriptions, message } from "antd";
import moment from "moment";
import { changeETARequest } from "@/services/loads";
import EnterETAsInputForm from "@/components/DispatchStepsModal/components/EnterETAsInputBody";
import ETAWindow from "@/components/ETAWindow";

const format = "MM/DD/YYYY";

const ChangeETAModal = ({ visible, loadData, onClose: propOnClose }) => {
  const formRef = useRef(null);

  const [shipmentsList, setShipmentsList] = useState([{ ...loadData.shipment, id: loadData.shipmentId }]);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const loadId = useMemo(() => {
    return loadData.id;
  }, [loadData?.id]);

  const { pickupEtaString, pickupTimeSlot, dropoffEtaString, dropoffTimeSlot } = useMemo(() => {
    return {
      pickupEtaString: loadData.pickupETA === null ? null : moment(loadData.pickupETA).format(format),
      pickupTimeSlot: null,
      dropoffEtaString: loadData.dropOffETA === null ? null : moment(loadData.dropOffETA).format(format),
      dropoffTimeSlot: null,
    };
  }, [loadData]);

  const createSingleShipmentPropertyValueUpdater = useCallback(
    (shipmentId, propertyName) => {
      const updater = updatedValue => {
        setShipmentsList(current => {
          const newShipmentsList = [...current];

          const shipmentToUpdate = newShipmentsList.find(shipment => shipment.id === shipmentId);

          shipmentToUpdate[propertyName] = updatedValue;

          return newShipmentsList;
        });
      };

      return updater;
    },
    [setShipmentsList],
  );

  const onClose = useCallback(() => {
    setShipmentsList(prevValue => {
      const index = prevValue.findIndex(shipment => {
        return shipment.id === loadData.shipmentId;
      });

      prevValue[index] = {
        ...prevValue[index],
        pickupETADate: null,
        pickupETATimeSlotIndex: null,
        dropoffETADate: null,
        dropoffETATimeSlotIndex: null,
      };

      return prevValue;
    });

    setLoadingSubmit(false);

    if (typeof propOnClose === "function") {
      propOnClose();
    }
  }, [loadData?.shipmentId, propOnClose]);

  const handleSubmitChangeETA = useCallback(() => {
    formRef.current
      .validateFields()
      .then(result => {
        setLoadingSubmit(true);
        changeETARequest(loadId, result)
          .then(() => {
            message.success("Successfully requested the ETA change");
          })
          .finally(() => {
            onClose();
          });
      })
      .catch(error => {
        console.error("invalid fields", error);
      });
  }, [loadId, onClose]);

  return (
    <Modal
      title="Change ETA Request"
      style={{ minWidth: "950px" }}
      visible={visible}
      confirmLoading={loadingSubmit}
      onOk={handleSubmitChangeETA}
      onCancel={onClose}
    >
      <Descriptions bordered column={1} style={{ marginBottom: "16px" }}>
        <Descriptions.Item key="pickupEta" label="Current Pickup ETA">
          <ETAWindow etaDate={pickupEtaString} etaTimeSlotIndex={pickupTimeSlot} />
        </Descriptions.Item>

        <Descriptions.Item key="dropoffEta" label="Current Dropoff ETA">
          <ETAWindow etaDate={dropoffEtaString} etaTimeSlotIndex={dropoffTimeSlot} />
        </Descriptions.Item>
      </Descriptions>

      <EnterETAsInputForm
        hideConfirmButton
        etasInputFormRef={formRef}
        shipmentsList={shipmentsList}
        setShipmentsList={value => setShipmentsList(value)}
        createSingleShipmentPropertyValueUpdater={createSingleShipmentPropertyValueUpdater}
      />
    </Modal>
  );
};

export default ChangeETAModal;
